export default __webpack_public_path__ + "static/media/tif.b4ac2f18.svg";